"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19.63 9.78 16.56 19H7.44L4.37 9.78 12 4.44z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19.63 9.78 16.56 19H7.44L4.37 9.78 12 4.44zM2 9l4 12h12l4-12-10-7z"
}, "1")], 'PentagonTwoTone');